
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d49947a8&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BranchCenter.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BranchCenter.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-d49947a8!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BranchCenter.vue"),
  /* scopeId */
  "data-v-d49947a8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/master/company/BranchCenter.vue
// module id = 788
// module chunks = 0